import { MDBDatatable, MDBIcon, MDBInput, MDBTextArea } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import PopupLoader from "../../../views/popups/PopupLoader";
import ToggleEditWarning from "../hunt/ToggleEditWarning";
import TextareaAutosize from 'react-textarea-autosize'
import { Tooltip } from "react-tooltip";
import { customSearch } from "../../CustomSearchUtil/CustomSearch";

function LunaAutoAttendant({
  aaGroups,
  aaTextValue,
  aaError,
  setaaError,
  onResetDone,
}) {
  const [selectAllRadio, setselectAllRadio] = useState("-1");
  const [updateFieldName, setupdateFieldName] = useState("");
  const [updateFieldValue, setupdateFieldValue] = useState("");
  const [toggleValue, settoggleValue] = useState(-1);
  const [columnName, setcolumnName] = useState("");
  const [editWarning, seteditWarning] = useState(false);
  const warningToggle = () => seteditWarning(!editWarning);
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [aaText, setaaText] = useState({});
  const [focusedIndex, setFocusedIndex] = React.useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [filteredIndices, setFilteredIndices] = useState([]);
  const {
    register,
    setValue,
    watch,
    setError,
    clearErrors,
    control,
    reset,
    formState: { errors },
  } = useFormContext();
  const { fields } = useFieldArray({
    name: "aa.edit_perm",
    control,
  });

  useEffect(() => {
    if (aaGroups && aaGroups.length > 0) {
      reset((prev) => ({ ...prev, aa: { ...prev.aa, edit_perm: aaGroups } }));
      onResetDone?.();
    }
  }, [aaGroups]);

  function handleAllChange(feildName, columnName, value) {
    clearErrors(`aa.is_perm_enabled`);
    setaaError("");
    if (value !== "-1") {
      setupdateFieldName(feildName);
      setupdateFieldValue(value);
      seteditWarning(true);
      // setuniqueKeyValue(resetFieldid);
      settoggleValue(value);
      setcolumnName(columnName);
    }
  }

  function handleCloseWarning() {
    setselectAllRadio("-1");
    warningToggle();
  }

  function handleUpdateToggle() {
    fields.forEach((field, index) => {
      setValue(
        `aa.edit_perm.${index}.${updateFieldName}`,
        updateFieldValue ? 1 : 0,
        {
          shouldDirty: true,
        }
      );
    });

    setselectAllRadio("-1");
    warningToggle();
  }
  
  useEffect(() => {
    setSearchValue("")
    if (fields && Array.isArray(fields) && fields.length > 0) {
      setFilteredIndices(fields.map((_, index) => index));
    } else {
      setFilteredIndices([]);
    }
  }, [fields.length]);
  useEffect(() => {
    if (aaTextValue && Object.entries(aaTextValue).length > 0) {
      setaaText(aaTextValue);
    }
  }, [aaTextValue]);

  useEffect(() => {
    // Cleanup function to clear timeout when component unmounts or input value changes
    return () => {
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
    };
  }, [typingTimeout]);

  function handleInfoChange(index, code, value) {
    setaaText((prev) => ({ ...prev, [code]: value }));
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    const newTimeout = setTimeout(() => {
      setValue(`aa.edit_perm.${index}.info`, value, {
        shouldDirty: true,
      });
      clearErrors(`aa.is_perm_enabled`);
    }, 1000);
    setTypingTimeout(newTimeout);
  }

  const handleSearch = (value) => {
    setSearchValue(value);

    if (!fields || fields.length === 0) {
      setFilteredIndices([]);
      return;
    }

    if (!value.trim()) {
      setFilteredIndices(fields.map((_, index) => index));
      return;
    }

    const filterResult = customSearch(fields, value, ["title", "extensions"]);

    const matchingIndices = filterResult
      .map((filteredItem) =>
        fields.findIndex(
          (field) =>
            field &&
            (field.id === filteredItem.id ||
              (field.title === filteredItem.title &&
                field.extensions === filteredItem.extensions))
        )
      )
      .filter((index) => index !== -1);

    setFilteredIndices(matchingIndices);
  };


    let processdrows = [];
 // Add safety check for fields and filteredIndices
  if (fields && fields.length > 0 && filteredIndices.length > 0) {
    filteredIndices.forEach((originalIndex) => {
      const aa = fields[originalIndex];
      
      // Additional safety check for the individual field object
      if (!aa || typeof aa !== 'object') return;
      
    const isFocused = focusedIndex === originalIndex;
    processdrows.push({
      aaInfo: aa,
      name: aa.title || '',
      extension: aa.extensions || '',
      information: (
        <>
          {watch(`aa.edit_perm.${originalIndex}.flag`) === 1 ? (
            <div className={`position-relative ${isFocused ? "" : "no-scrollbar-textarea"}`}>
              <TextareaAutosize
                minRows={isFocused ? 9 : 3}
                maxRows={isFocused ? 9 : 3}
                className="w-100  "
                type="text"
                maxLength={500}
                // value={aaText[aa.code] || ""}
                {...register(`aa.edit_perm.${originalIndex}.info`)}
                onFocus={() => setFocusedIndex(originalIndex)}
                onBlur={(e) => {
                  // Check if the related target is the toggle switch
                  const relatedTarget = e.relatedTarget;
                  if (relatedTarget && relatedTarget.closest('.phoneselect')) {
                    return; // Don't blur if clicking on the toggle
                  }
                  setFocusedIndex(null);
                }}
                onChange={(e) => {
                  // clearErrors(`aa.is_perm_enabled`);
                  setaaError("");
                  // handleInfoChange(index, aa.code, e.target.value);
                  setValue(`aa.edit_perm.${originalIndex}.info`, e.target.value, {
                    shouldDirty: true,
                  });
                  clearErrors(`aa.is_perm_enabled`);
                }}
              />
              <div
                className="  text-muted text-end lh-normal pe-1 pb-1 "
                style={{
                  fontSize: "10.5px",
                  pointerEvents: "none"
                }}
              >
                {watch(`aa.edit_perm.${originalIndex}.info`)?.length || 0}/500
              </div>
            </div>
          ) : (
            ""
          )}
        </>
      ),
      active: (
        <>
          <div className="d-flex align-items-center flex-column justify-content-center">
            <div className="phoneselect">
              <label className="switch">
                <input
                  className="form-control"
                  type="checkbox"
                  checked={watch(`aa.edit_perm.${originalIndex}.flag`) === 1}
                  onChange={(e) => {
                    setaaError("");
                    clearErrors(`aa.is_perm_enabled`);
                    setValue(
                      `aa.edit_perm.${originalIndex}.flag`,
                      e.target.checked ? 1 : 0,
                      { shouldDirty: true }
                    );
                  }}
                  name="DefualtLocation"
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
        </>
       ),
      });
    });
  }

  const AutoAttendants = {
    columns: [
      {
        label: (
          <>
            Name
          </>
        ),
        field: "name",
      },
      {
        label: (
          <>
            Extension
          </>
        ),
        field: "extension",
      },
      ,
      {
        label: (
          <>
            <div className="fw-bold">Information <MDBIcon icon="info-circle" className="ms-3 aa_info" /></div>
          </>
        ),
        field: "information",
        sort: false,
      },
      {
        label: (
          <>
            <div className="d-flex align-items-center flex-column justify-content-center">
              <p className="fw-bold">Active</p>

              {/* <div className="three-checkbox round2 mx-0">
                <input
                  type="radio"
                  name="ActiveValue04"
                  checked={selectAllRadio === false}
                  onChange={(e) => {
                    if (e) {
                      setselectAllRadio(false);
                      handleAllChange("flag", "Active", false);
                    }
                  }}
                />
                <input
                  type="radio"
                  name="ActiveValue04"
                  checked={selectAllRadio === "-1"}
                  onChange={(e) => {
                    if (e) {
                      setselectAllRadio("-1");
                      handleAllChange("flag", "Active", "-1");
                    }
                  }}
                />
                <input
                  type="radio"
                  name="ActiveValue04"
                  checked={selectAllRadio === true}
                  onChange={(e) => {
                    if (e) {
                      setselectAllRadio(true);
                      handleAllChange("flag", "Active", true);
                    }
                  }}
                />
                <span className="slider"></span>
              </div> */}
            </div>
          </>
        ),
        field: "active",
        sort: false,
      },
    ],
    rows: processdrows,
  };

  return (
    <>
      <div className="section-content">
        <div className="d-flex align-items-center justify-content-between mb-3 pe-4">
          <div className="general-settings m-0">Auto Attendants</div>
          <div className="phoneselect">
            <label className="switch">
              <input
                className="form-control"
                type="checkbox"
                name="DefualtLocation"
                value={watch(`aa.is_perm_enabled`)}
                checked={watch(`aa.is_perm_enabled`)}
                onChange={(e) => {
                  clearErrors(`aa.is_perm_enabled`);
                  setaaError("");
                  setValue(`aa.is_perm_enabled`, e.target.checked, {
                    shouldDirty: true,
                  });
                }}
              />
              <span className="slider round"></span>
            </label>
            {errors?.aa?.is_perm_enabled && (
              <p className="text-danger">
                {errors?.aa?.is_perm_enabled?.message}
              </p>
            )}
          </div>
        </div>
        {aaError && <p className="text-danger">{aaError}</p>}
        {watch("aa.is_perm_enabled") && (
          <>
            <div className="actionbar"></div>
               <div className='mb-2 mt-0 position-relative w-auto'>
                          <MDBInput
                            label="Search"
                            value={searchValue}
                            onChange={(e) => handleSearch(e.target.value)}
                          />
                          <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                        </div>
            <MDBDatatable
              // search
              className="actioncolumn LunaAutoAttendantsDataTable"
              // pagination={false}
                key={searchValue}
              fixedHeader
              hover
              data={AutoAttendants}
            />
          </>
        )}
      </div>
      {editWarning && (
        <PopupLoader
          size="md"
          title="Warning"
          content={
            <ToggleEditWarning
              handleUpdateToggle={handleUpdateToggle}
              handleCloseWarning={handleCloseWarning}
              toggleValue={null}
              columnName={columnName}
              isLuna={true}
            />
          }
          onShow={seteditWarning}
          onClose={handleCloseWarning}
        />
      )}

      <Tooltip anchorSelect=".aa_info" place="top" className="exampleTooltipLight">
        Tells Luna what each active Auto Attendant is Used for.
      </Tooltip>
    </>
  );
}

export default React.memo(LunaAutoAttendant);
